const RegisterStep5Details = ({ registration }) => {
  return 'Step 5'
}

export default RegisterStep5Details
